function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import gettext from 'js-utils/gettext';
import GREYS_JSON from '../../color/color_greys.json';
import Illustration from '../../illustration/Illustration';
import { IMAGE_STYLE_FIXED } from './constants';
import { getRandomFallbackImage } from '../utils';
import ActionWrapper from './ActionWrapper';

var Image =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Image, _PureComponent);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, _getPrototypeOf(Image).apply(this, arguments));
  }

  _createClass(Image, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          linkUrl = _this$props.linkUrl,
          imageUrl = _this$props.imageUrl,
          _this$props$imageAlt = _this$props.imageAlt,
          imageAlt = _this$props$imageAlt === void 0 ? gettext('Event image') : _this$props$imageAlt,
          imageStyle = _this$props.imageStyle,
          hasNoTabIndex = _this$props.hasNoTabIndex,
          placeholderBgColor = _this$props.placeholderBgColor,
          isTargetBlank = _this$props.isTargetBlank,
          isNoFollow = _this$props.isNoFollow,
          isConsumer = _this$props.isConsumer,
          isLazyImage = _this$props.isLazyImage;
      var imageClassNames = classNames('eds-event-card-content__image', {
        'eds-max-img': imageStyle === IMAGE_STYLE_FIXED
      });
      var imageWrapperClassNames = classNames('eds-event-card-content__image-wrapper', {
        'eds-event-card-content__image-wrapper--with-width': !linkUrl,
        'eds-event-card-content__image-wrapper--sharp-corners': isConsumer
      });
      var imageContentClassNames = classNames('eds-event-card-content__image-content', {
        'eds-event-card-content__image-content--sharp-corners': isConsumer
      });
      var placeholderStyles = {
        backgroundColor: placeholderBgColor
      };
      var image = null;

      if (isLazyImage || !imageUrl) {
        image = React.createElement("div", {
          className: "eds-event-card-content__image--svg"
        }, React.createElement(Illustration, {
          type: getRandomFallbackImage(imageAlt),
          width: "100%",
          height: "100%"
        }));
      } else if (imageUrl) {
        image = React.createElement("img", {
          className: imageClassNames,
          src: imageUrl,
          alt: imageAlt
        });
      }

      return React.createElement(ActionWrapper, {
        onClick: onClick,
        linkUrl: linkUrl,
        linkAlt: imageAlt,
        hasNoTabIndex: hasNoTabIndex,
        isTargetBlank: isTargetBlank,
        isNoFollow: isNoFollow
      }, React.createElement("div", {
        className: imageWrapperClassNames
      }, React.createElement("div", {
        className: imageContentClassNames
      }, React.createElement("div", {
        className: "eds-event-card-content__image-placeholder",
        style: placeholderStyles
      }), image)));
    }
  }]);

  return Image;
}(PureComponent);

_defineProperty(Image, "propTypes", {
  onClick: PropTypes.func,
  linkUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.oneOfType([PropTypes.string, EBPropTypes.translation]),
  imageStyle: PropTypes.string,
  hasNoTabIndex: PropTypes.bool,
  placeholderBgColor: PropTypes.string,
  isTargetBlank: PropTypes.bool,
  isNoFollow: PropTypes.bool,
  isConsumer: PropTypes.bool,
  isLazyImage: PropTypes.bool
});

_defineProperty(Image, "defaultProps", {
  placeholderBgColor: GREYS_JSON['grey-200']
});

export { Image as default };